
import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

interface FormActionButtonsProps {
  isSubmitting: boolean;
  isEditing: boolean;
}

export const FormActionButtons: React.FC<FormActionButtonsProps> = ({ 
  isSubmitting, 
  isEditing 
}) => {
  const navigate = useNavigate();
  
  return (
    <div className="flex justify-between pt-4">
      <Button 
        type="button" 
        variant="outline" 
        onClick={() => navigate(-1)}
      >
        Annuler
      </Button>
      <Button 
        type="submit"
        disabled={isSubmitting}
      >
        {isEditing ? "Mettre à jour" : "Planifier"} l'activité
      </Button>
    </div>
  );
};
